<template>
  <span
    class="auth-login__brand-logo"
    :style="logoStyle"
    role="img"
    aria-label="RemoniHealth"
  />
</template>

<script setup>
import { computed, inject, unref } from 'vue'

const props = defineProps({
  src: { type: String, default: '' },
})

const injectedUrl = inject('authBrandLogoUrl', '/images/global/brand-logo.svg')

const logoUrl = computed(() => {
  if (props.src) {
    return props.src
  }

  const resolved = unref(injectedUrl)

  return resolved || '/images/global/brand-logo.svg'
})

const logoStyle = computed(() => ({
  '--auth-brand-logo-src': `url("${logoUrl.value}")`,
}))
</script>
